
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#000","fill-rule":"nonzero","d":"M7.413 11.234l3.607 3.384c.543.51 1.42.51 1.964 0l3.607-3.384c.877-.823.25-2.234-.99-2.234H8.389c-1.24 0-1.852 1.411-.975 2.234z"}})])])
          )
        }
      }
    